import React from "react";
import { Badge, colors } from "../design/badge";
import { CustodyStatus } from "@visitproof/types";

interface CustodyStatusBadgeProps {
  status: CustodyStatus | string;
}

const CustodyStatusBadge: React.FC<CustodyStatusBadgeProps> = ({ status }) => {
  let color;
  let title;

  switch (status) {
    case "custodial":
      color = "green";
      title = "Custodial";
      break;
    case "non-custodial":
      color = "red";
      title = "Non-Custodial";
      break;
    case "joint-custodial":
      color = "blue";
      title = "Joint Custodial";
      break;
    default:
      color = "gray";
      title = "Unknown";
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default CustodyStatusBadge;
